import request from "_private/utils/request";
// let mock = "/mock/5c7fb1b653377c002106962b";
let mock = "";

const requestAjax = function(rOpts) {
  let opts = {
    url: "",
    method: "post",
    headers: { type: "json" },
    data: {}
  };
  opts = Object.assign(opts, rOpts);
  return request({
    url: mock + opts.url,
    method: opts.method,
    headers: opts.headers,
    data: opts.data
  });
};

const fetchVehicleTree = function() {
  return requestAjax({
    url: "/monitorCenter/monitorVehicle/getVehicleTree"
  });
};
//请求冷配车辆树形列表数据（广东）
const fetchPassCheckVehicleTree = function() {
  return requestAjax({
    url: "/monitorCenter/monitorVehicle/getVehiclePassCheckInfoTree"
  });
};
//请求冷库树形列表（广东）
const fetchStorageTree = function() {
  return requestAjax({
    url: "/monitorCenter/monitorMapStorage/getStorageTree"
  });
};

//请求设置数据 (新增)
const fetchSetting = function() {
  return requestAjax({
    url: "/monitorCenter/monitorMapStorage/getLocationSetting"
  });
};

//保存设置数据
const saveSetting = function(data) {
  return requestAjax({
    url: "/monitorCenter/monitorMapStorage/saveLocationSetting",
    data
  });
};

//请求定位数据 (删)
const fetchLocation = function(data) {
  return requestAjax({
    url: "/monitorCenter/monitorVehicle/getVehiclesLocationList",
    data
  });
};
//请求定位数据 (新增)
const fetchStorageLocationList = function(data) {
  return requestAjax({
    url: "/monitorCenter/monitorMapStorage/getStorageLocationList",
    data
  });
};

// 发送拍照指令
const sendDirective_photo = function(data) {
  return requestAjax({
    url: "/monitorCenter/monitor/sendPictureCommand",
    data
  });
};
// 发送LCD短信
const sendDirective_lcd = function(data) {
  return requestAjax({
    url: "/monitorCenter/monitor/sendCommonMessageCommand",
    data
  });
};
// 获取固定短信列表
const fetchMsg_lcd = function() {
  return requestAjax({
    url: "/monitorCenter/monitor/findCommonMessageList"
  });
};
// 保存固定短信
const saveNewMsg_lcd = function(data) {
  return requestAjax({
    url: "/monitorCenter/monitor/saveCommonMessage",
    data
  });
};
// 删除固定短信
const deleteMsg_lcd = function(data) {
  return requestAjax({
    url: "/monitorCenter/monitor/deleteCommonMessage",
    data
  });
};
// 点名
const sendDirective_call = function(data) {
  return requestAjax({
    url: "/monitorCenter/monitor/sendRollCallCommand",
    data
  });
};
// SD卡照片提取
const sendDirective_sd = function(data) {
  return requestAjax({
    url: "/monitorCenter/monitor/sendSDCardPhotoCommand",
    data
  });
};
// 时间点查车
const fetchVehicle_timeSearch = function(data) {
  return requestAjax({
    url: "/monitorCenter/monitor/getTrackByTime",
    data
  });
};
// 导出Excel
const exportExcel = function(data) {
  let exportUrl = "/monitorCenter/monitorMapStorage/exportStorageLocationList";
  if (data.storageIdList.length > 0) {
    exportUrl += "?storageIdList=" + data.storageIdList;
  }
  document.location.href = exportUrl;
};

const exportExcel_pullRect = function(data) {
  let exportUrl = "/monitorCenter/logistics/exportVehicleListByRect";
  if (data.vehicleIdList.length > 0) {
    exportUrl += "?vehicleIdList=" + data.vehicleIdList;
  }
  document.location.href = exportUrl;
};

// 主动安全
const fetchCount_safeEventApi = function() {
  return requestAjax({
    url: "/monitorCenter/monitor/getTodayADASCount"
  });
};
const fetchList_safeEventApi = function() {
  return requestAjax({
    url: "/monitorCenter/monitor/getTodayADASList"
  });
};
const handle_safeEventApi = function(data) {
  return requestAjax({
    url: "/monitorCenter/monitor/saveADASHandle",
    data
  });
};

export default {
  fetchStorageTree, // 新增
  fetchStorageLocationList, // 新增
  fetchVehicleTree,
  fetchSetting,
  saveSetting,
  fetchLocation,
  sendDirective_photo,
  sendDirective_lcd,
  fetchMsg_lcd,
  saveNewMsg_lcd,
  deleteMsg_lcd,
  sendDirective_call,
  sendDirective_sd,
  fetchVehicle_timeSearch,
  exportExcel,
  exportExcel_pullRect,
  fetchCount_safeEventApi,
  fetchList_safeEventApi,
  handle_safeEventApi,
  fetchPassCheckVehicleTree
};
